export const pepColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'governingInstitution',
    label: 'Institution',
    sortable: false,
  },
  {
    name: 'governingRole',
    label: 'Role',
    sortable: false,
  },
  {
    name: 'effectiveDateValue',
    label: 'Effective',
    sortable: false,
  },
  {
    name: 'expirationDateValue',
    label: 'Expiration',
    sortable: false,
  },
  {
    name: 'flags',
    label: 'Flags',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];

export const sactionsColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'sourceName',
    label: 'Source',
    sortable: false,
  },
  {
    name: 'administrativeUnitName',
    label: 'Country',
    sortable: false,
  },
  {
    name: 'isoStandard',
    label: 'ISO',
    sortable: false,
  },
  {
    name: 'designations',
    label: 'Designations',
    sortable: false,
  },
  {
    name: 'consolidated',
    label: 'Consolidated',
    sortable: false,
  },
  {
    name: 'lastUpdated',
    label: 'Updated',
    sortable: false,
  },
];
